import ControlButton from 'widget/components/ControlButton';
import mediaQueries from 'styles/mediaQueries';
import mediaQueryBuilder from 'styles/helpers/mediaQueryBuilder';
import styled from '@emotion/styled';

type Props = {
  'data-test'?: string;
  onClick: () => void;
  sizeToHide: string;
};

const StyledPlayNextButton = styled(ControlButton)<Props>(({ sizeToHide }) => ({
  paddingTop: '0.3rem',
  [mediaQueryBuilder(`${sizeToHide}`)]: {
    display: 'none',
  },
  [mediaQueryBuilder([
    mediaQueries.max.height['99'],
    mediaQueries.min.width['399'],
  ])]: {
    float: 'right',
  },
  [mediaQueryBuilder([
    mediaQueries.max.height['79'],
    mediaQueries.max.width['400'],
  ])]: {
    display: 'none',
  },
}));

export default StyledPlayNextButton;
